import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ElevatorPriceLifeTime extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)


            this.state = {
                  ElevatorPriceLifeTime: this.props.ElevatorPriceLifeTime,
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
            }
      }




      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }



      handleChangeLifeTimePercent = (event) => {
            var temparray = this.state.ElevatorPriceLifeTime
            temparray.elevator_price_life_time_percent = event
            this.setState({ ElevatorPriceLifeTime: temparray })
      }

      handleChangeLifeTimeFrom = (event) => {
            var temparray = this.state.ElevatorPriceLifeTime
            temparray.elevator_price_life_time_from = event
            this.setState({ ElevatorPriceLifeTime: temparray })
      }

      handleChangeLifeTimeTo = (event) => {
            var temparray = this.state.ElevatorPriceLifeTime
            temparray.elevator_price_life_time_to = event
            this.setState({ ElevatorPriceLifeTime: temparray })
      }



      modifyNewInstalmentCondition = () => {
            const { ElevatorPriceLifeTime } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_price_life_time")
            fd.append("elevator_price_life_time_id", ElevatorPriceLifeTime.elevator_price_life_time_id)
            fd.append("elevator_price_life_time_from", ElevatorPriceLifeTime.elevator_price_life_time_from)
            fd.append("elevator_price_life_time_to", ElevatorPriceLifeTime.elevator_price_life_time_to)
            fd.append("elevator_price_life_time_percent", ElevatorPriceLifeTime.elevator_price_life_time_percent)

            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { ElevatorPriceLifeTime } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_price_life_time")
            fd.append("elevator_price_life_time_id", ElevatorPriceLifeTime.elevator_price_life_time_id)

            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const {  snackMode, snackstr, showSnack, visible ,  ElevatorPriceLifeTime } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                        type="number"
                                        placeholder="از سال"
                                        handleInputt={this.handleChangeLifeTimeFrom}
                                        value={ElevatorPriceLifeTime.elevator_price_life_time_from}
                                    />
                              </Grid>

                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                        type="number"
                                        placeholder="تا سال"
                                        handleInputt={this.handleChangeLifeTimeTo}
                                        value={ElevatorPriceLifeTime.elevator_price_life_time_to}
                                    />
                              </Grid>


                              <Grid item xs={4}>
                                    <FloatingLabelInput
                                        type="percent"
                                        placeholder="درصد اضافه نرخ"
                                        handleInputt={this.handleChangeLifeTimePercent}
                                        value={ElevatorPriceLifeTime.elevator_price_life_time_percent}
                                    />
                              </Grid>

                              <Grid item xs={4}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(ElevatorPriceLifeTime)
